let Global = {
  sessionId: null,
  gameTry: 0,
  delta: 0,
  shootCnt: 0,
  xPadd: 0,
  age: 0,
  goBackTo: null,
  isGameActive: false,
  introShown: false,
  introActive: false,
  totalGoalsSaved: 0,
  timeTaken: 0,
  scaleFact: 1,
  soundEnabled: true,
  limitReached: false,
  userKey: null,
  jumpHeight: 'high',
  avatarName: null,
  gender: null,
  userName: '',
  email: null,
  mobile: null,
  location: null,
  IGHandle: null,
  yob: null,
  cameraPanTime: 5 * 1,
  BASE_URL: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/',
  URL_CREATE: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/create.php',
  URL_DATA: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/data.php',
  URL_LEADER: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/getLeader.php',
  URL_JERSEY: 'https://www.newsfeedsmartapp.com/CarlsbergPenalty/jersey.php',
  URL_VUPDATE:
    'https://www.newsfeedsmartapp.com/CarlsbergPenalty/valueUpdator.php',

  assets: {
    cubemap: {},
    glbs: {
      flag: {
        key: 'flag',
        path: ['./models/flag.glb'],
        asset: null,
      },
      flash: {
        key: 'flash',
        path: ['./models/flash.glb'],
        asset: null,
      },
      stadium: {
        key: 'stadium',
        path: ['./models/stadium.glb'],
        asset: null,
      },

      collider: {
        key: 'collider',
        path: ['./models/collider.glb'],
        asset: null,
      },
      shooter: {
        key: 'shooter',
        path: ['./models/shooter.glb'],
        asset: null,
      },

      keeperMale: {
        key: 'keeperMale',
        path: ['./models/keeperM.glb'],
        asset: null,
      },
      keeperFemale: {
        key: 'keeperFemale',
        path: ['./models/keeperFM.glb'],
        asset: null,
      },

      ball: {
        key: 'ball',
        path: ['./models/ball.glb'],
        asset: null,
      },
    },
    textures: {
      shadow: {
        key: 'shadow',
        path: ['./textures/shadow.png'],
        asset: null,
      },
      // net: {
      //   key: 'net',
      //   path: ['./textures/net.png'],
      //   asset: null,
      // },
      trail: {
        key: 'trail',
        path: ['./textures/trail.png'],
        asset: null,
      },
    },
    sounds: {
      catch: {
        key: 'catch',
        path: ['./sounds/catch.mp3'],
        asset: null,
      },
      crowd: {
        key: 'crowd',
        path: ['./sounds/crowd.mp3'],
        asset: null,
      },
      kick: {
        key: 'kick',
        path: ['./sounds/kick.mp3'],
        asset: null,
      },
      miss: {
        key: 'miss',
        path: ['./sounds/miss.mp3'],
        asset: null,
      },
      blow: {
        key: 'blow',
        path: ['./sounds/blow.mp3'],
        asset: null,
      },
      net: {
        key: 'net',
        path: ['./sounds/net.mp3'],
        asset: null,
      },
      cheer: {
        key: 'cheer',
        path: ['./sounds/cheer.mp3'],
        asset: null,
      },
      music: {
        key: 'music',
        path: ['./sounds/music.mp3'],
        asset: null,
      },
    },
  },
};
export { Global };
